import React from 'react';
import useSet from 'react-use/lib/useSet';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../../../../../../CommonComponents/OPL/Button/Button';
import { Checkbox } from '../../../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { ListDivider } from '../../../../../../../../CommonComponents/OPL/List/ListDivider';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { usePlans } from '../../../../../../hooks/usePlans';
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from '../../../../../../../../CommonComponents/OPL/Popover/Popover';
import { PLANS_MAX_COUNT, PLANS_MIN_COUNT } from '../../RetirementSideBySide.meta';

interface Props {
  clientId: string;
  defaultSelected?: string[];
  anchorEl?: React.ReactElement;
  onApply(selectedSet: string[]): void;
}

export const PlansSelector = ({ clientId, defaultSelected, onApply, anchorEl }: Props) => {
  const [selectedSet, { has, toggle, reset }] = useSet(new Set(defaultSelected || []));

  const plans = usePlans({ clientId });

  const canReset = !defaultSelected || defaultSelected.length === 0;

  return (
    <Popover>
      <PopoverTrigger>
        {anchorEl || (
          <Button variant="secondary" rightIcon="fas fa-caret-down">
            <Text mr="16">{selectedSet.size > 0 ? selectedSet.size : 'No'} Plans Selected</Text>
          </Button>
        )}
      </PopoverTrigger>

      <PopoverContent width={240}>
        {plans.map(({ planId, name }) => (
          <Checkbox
            key={planId}
            checked={has(planId)}
            onChange={() => toggle(planId)}
            disabled={!has(planId) && selectedSet.size === PLANS_MAX_COUNT}
            isOverflowWrap
            mx="4"
            my="8"
          >
            {name}
          </Checkbox>
        ))}

        <ListDivider />

        <Box display="flex" justifyContent={canReset ? 'space-between' : 'flex-end'} px="16" py="8">
          {canReset && (
            <Button variant="subtleInactive" onClick={reset}>
              Reset
            </Button>
          )}

          <PopoverClose>
            <Button
              onClick={() => {
                const planIds = plans.map(({ planId }) => planId).filter(has);

                onApply(planIds);
              }}
              disabled={selectedSet.size < PLANS_MIN_COUNT}
            >
              Apply
            </Button>
          </PopoverClose>
        </Box>
      </PopoverContent>
    </Popover>
  );
};
